export const MAPAL = 'mapal';
